class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }

    var is_northern_ireland_market = localStorage.getItem('is_northern_ireland_market');
    var sd = $.getScript("https://cdn.shopify.com/s/javascripts/currencies.js");
    if(is_northern_ireland_market === 'true'){
      jQuery('#product-grid li').each(function(){
          var price_container_id = jQuery(this).find('.price__container').attr('data-id');
          var vprice = jQuery(this).find('.price__container .price__regular .price-item').html();
          var price_prefix = '';
          if(vprice.indexOf('From') != -1){
            price_prefix = 'From';
          }
          var amountInEURRoundUpArr = vprice.split('.');
          vprice = vprice.replace(",", ".");
          vprice = vprice.replace("€", "");
          vprice = vprice.replace("From", "");
          vprice = jQuery.trim(vprice);
        
          var convertedAmount = vprice*ex_eur/ex_gbp;

          var perprice = (convertedAmount * 20/100).toFixed(2); 
          convertedAmount = convertedAmount-perprice;
          var final_convertedAmount = (convertedAmount).toFixed(2);
          var roundUPNearstPrice = (100-amountInEURRoundUpArr[1])/100;
          final_convertedAmount = Math.round(final_convertedAmount)-roundUPNearstPrice;
        
          $('[data-id="'+price_container_id+'"] .price__regular .price-item').html(price_prefix+' £'+final_convertedAmount);

          // if($('[data-id="'+price_container_id+'"] .price').hasClass('price--on-sale')){
          //   $('[data-id="'+price_container_id+'"] .price__container .price-item--sale').html(price_prefix+' £'+parseFloat(finalvariantPrice).toFixed(2));
          // }else{
          //   $('[data-id="'+price_container_id+'"] .price__container .price-item').html(price_prefix+' £'+parseFloat(finalvariantPrice).toFixed(2));
          // }
      });
    }
    
    var countrycode = 'GB';
    var checkMarket = $('input[name="country_code"]').val();
    if(checkMarket == 'IE'){
      countrycode = 'IE';
    }
    var is_northern_ireland_market = localStorage.getItem('is_northern_ireland_market');
    if(is_northern_ireland_market === 'true'){
      countrycode = 'GB';
    }
    jQuery('#product-grid li').each(function(){
          var productID = $(this).attr('data-product-id');
          fetch(`https://matthews42.sg-host.com/product_variant_location.php?product_id=${productID}&countrycode=${countrycode}`)
          .then(response => response.json())
          .then(data => {
            //var market_loc_id = '{{ localization.market.metafields.custom.locationIDs.value }}';
            var market_loc_id = $('body').attr('data-loc-id');

            var marketLocArray = [];
            if (typeof market_loc_id === 'string') {
              marketLocArray = market_loc_id.split(',').map(id => id.trim()).filter(id => id !== '');
            } else if (Array.isArray(market_loc_id)) {
              marketLocArray = market_loc_id;
            } else {
              marketLocArray = [market_loc_id];
            }

            var currentLocInv = 0;
            var finalvariantPrice = Infinity;
             var variantinventoryPolicy = '';
              var varianttracked = '';
            data.variants.forEach(variant => {
              const variantIdFull = variant.variant_id;
              const variantId = variantIdFull.split('/').pop();
               const eachvariantPrice = variant.price;
                variantinventoryPolicy = variant.inventoryPolicy;
                 varianttracked = variant.tracked;
                variant.inventory_levels.forEach(inventory => {
                    const locationName = inventory.location_name;
                    const location_id = inventory.location_id;
                    const final_loc_id = location_id.split('/').pop();            
                    const availableQuantity = inventory.available_quantity;
                      //if(final_loc_id == market_loc_id){
                      if (marketLocArray.includes(final_loc_id)) {
              
                        currentLocInv += availableQuantity;
                        //if(currentLocInv > 0){
                          if (!isNaN(eachvariantPrice) && eachvariantPrice < finalvariantPrice) {
                            finalvariantPrice = eachvariantPrice;
                          }
                        //}
                      }
                  });
            });
            var priceprefix = '£';
            if(countrycode == 'IE'){
              priceprefix = '€';
            }
            //$('.grid__item[data-product-id='+productID+'] .price__container .price-item').html(priceprefix+''+finalvariantPrice);
            if($('.grid__item[data-product-id='+productID+'] .price').hasClass('price--on-sale')){
              $('.grid__item[data-product-id='+productID+'] .price__container .price-item--sale').html(priceprefix+''+parseFloat(finalvariantPrice).toFixed(2));
            }else{
              $('.grid__item[data-product-id='+productID+'] .price__container .price-item').html(priceprefix+''+parseFloat(finalvariantPrice).toFixed(2));
            }
            
            if(currentLocInv <= 0){
              if(variantinventoryPolicy == 'CONTINUE' || !varianttracked){
                  $('.grid__item[data-product-id='+productID+']').addClass('availbleLoc');
                  //$("#product-grid li:eq(0)").before($('#product-grid .grid__item[data-product-id='+productID+']'));
              }else{
                $('.grid__item[data-product-id='+productID+']').addClass('notAvailbleLoc');
              }
              
              $('.grid__item[data-product-id='+productID+']').addClass('notAvailbleLoc');
            }else{
              $('.grid__item[data-product-id='+productID+']').addClass('availbleLoc');
              //$("#product-grid li:eq(0)").before($('#product-grid .grid__item[data-product-id='+productID+']'));
            }
          }).catch(error => console.error('Error fetching inventory data:', error));
    });
  }
  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);
    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });
    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }
  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })
    FacetFiltersForm.toggleActiveFacets(false);
  }
  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];
    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }
  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');
    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');
    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }
  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }
  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }
  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }
  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }
  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
